import { API } from "@/lib/api";
import { getConsent, track } from "@/lib/consent";

const KEY = "wlr_attr";
let memory = null;
let captured = false;

export const KINGSMOSS_URL = "https://kingsmosslogsni.co.uk";
export const KINGSMOSS_ONE_OFF = `${KINGSMOSS_URL}/?utm_source=weelogrun&utm_medium=referral&utm_campaign=one_off_orders`;

const clean = (v) => (v || "").toLowerCase().replace(/[^a-z0-9_.-]/g, "").slice(0, 60);

// Anonymous aggregate count only; no identifiers are sent.
const beacon = (body) => {
  try {
    const json = JSON.stringify(body);
    const sent = navigator.sendBeacon?.(`${API}/track`, new Blob([json], { type: "application/json" }));
    if (!sent) fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: json, keepalive: true });
  } catch {
    /* tracking must never break the page */
  }
};

export const captureAttribution = () => {
  if (captured) return;
  captured = true;
  const p = new URLSearchParams(window.location.search);
  const source = clean(p.get("utm_source"));
  if (!source) return;
  memory = { source, medium: clean(p.get("utm_medium")), campaign: clean(p.get("utm_campaign")), landing: window.location.pathname.slice(0, 100) };
  if (getConsent()?.analytics) sessionStorage.setItem(KEY, JSON.stringify(memory));
  beacon({ event: "utm_landing", source, campaign: memory.campaign });
  track("utm_landing", memory);
};

export const getAttribution = () => {
  if (memory) return memory;
  try {
    return JSON.parse(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const trackKingsmossClick = (placement) => {
  beacon({ event: "outbound_click", source: "kingsmoss", placement });
  track("outbound_click", { destination: "kingsmosslogsni.co.uk", placement });
};
